module.exports = __webpack_public_path__ + "a8a10a3e/img/archive-icon.0a6a9de3.svg";